import { Button, Dropdown, Menu, Steps, Tag } from "antd"
import React from "react"
import { RightOutlined, DownOutlined } from "@ant-design/icons"
import { GREEN } from "@finway-group/shared/lib/consts"
import { useWorkflows } from "Shared/hooks/workflow.hooks"
import { CurrencyService } from "Shared/services"
import { useTranslation } from "react-i18next"
import { getActiveWorkflowRule, getApproverForRule, getApproverLabelData, shouldSkipRule } from "Features/pages/workflows/workflow.utils"
import PriceLabel from "./priceLabel"
import { PriceIntervalEnum, WorkflowConditionEnum, WorkflowRule } from "@finway-group/shared/lib/models"
import WorkflowConditionTag from "Features/pages/workflows/workflowConditionTag"

interface WorkflowIndicatorInterface {
    expense: any
}

const WorkflowIndicator: React.FC<WorkflowIndicatorInterface> = ({ expense }) => {
    const { t } = useTranslation()

    const workflows = useWorkflows()
    const { workflow, activeRule } = getActiveWorkflowRule(expense, workflows)
    const currentFirstApproverData = getApproverLabelData(activeRule?.approverData)

    const dropDownMenu = () => (
        <Menu>
            <Menu.Item className="flex items-center min-w-190">
                <div className="workflows">
                    <Steps direction="vertical" className="mt-20 ml-10" size="small" current={(activeRule?.order || 1) - 1}>
                        {workflow?.rules
                            .sort((a: WorkflowRule, b: WorkflowRule) => a.order - b.order)
                            .map((rule: WorkflowRule) => {
                                const approverData = getApproverLabelData(rule.approverData)
                                const secondApproverData = getApproverLabelData(rule.secondApprover)

                                const isApproversEqual = getApproverForRule(rule.approverData, expense) === getApproverForRule(rule.secondApprover, expense)
                                const skipped = isApproversEqual || shouldSkipRule(rule, expense)

                                return (
                                    <Steps.Step
                                        key={rule.order}
                                        title={
                                            <>
                                                <span>{approverData?.label}</span>
                                                {rule.condition && <WorkflowConditionTag condition={rule.condition} />}
                                                {secondApproverData && <span>{secondApproverData.label}</span>}
                                                {rule.condition === WorkflowConditionEnum.IF && rule.amount && (
                                                    <>
                                                        <PriceLabel value={rule.amount} currency={rule.currency} interval={PriceIntervalEnum.ONE_TIME} />
                                                    </>
                                                )}
                                                {skipped ? t("label:skipped") : ""}
                                            </>
                                        }
                                    />
                                )
                            })}
                    </Steps>
                </div>
            </Menu.Item>
        </Menu>
    )

    return (
        <Dropdown overlay={dropDownMenu} trigger={["click"]} className="flex items-center z-100">
            <Button className="btn-default m-5">
                <Tag className="ant-tag ant-tag-green-highlight pb-2 mr-8" color="primary">
                    {activeRule?.order || 1}/{workflow?.rules.length}
                </Tag>
                <span>{t("label:workflow.approver")}</span>
                <RightOutlined size={12} style={{ color: GREEN }} />
                <span>
                    {activeRule?.secondApprover ? t("label:workflow.multiple_approvers") : `${currentFirstApproverData?.label}`}
                    <DownOutlined className="ml-4 mt-2" />
                </span>
            </Button>
        </Dropdown>
    )
}

export default WorkflowIndicator
